import type { Action } from '@reduxjs/toolkit'
import type { RootState } from './store'
import { getStore } from './storeRegistry'

export function appStoreSelect<T>(selector: (state: RootState) => T) {
  return selector(getStore().getState())
}

export function appStoreDispatch(action: Action) {
  return getStore().dispatch(action)
}

export function waitForSelectorValue<T = boolean>(
  selector: (state: RootState) => T,
  expectedValue: T,
  timeoutMs = 12000
): Promise<void> {
  const store = getStore()
  return new Promise<void>((resolve, reject) => {
    const initial = selector(store.getState())
    if (initial === expectedValue) {
      resolve()
      return
    }

    const cleanup = store.subscribe(() => {
      const value = selector(store.getState())
      if (value === expectedValue) {
        clearTimeout(timeoutId)
        resolve()
        cleanup()
      }
    })
    const timeoutId = setTimeout(() => {
      cleanup()
      reject(new Error('Timeout waiting for selector value'))
    }, timeoutMs)
  })
}
